import React, { useState, useEffect, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import "./CardSection.css";
import { useNavigate } from "react-router-dom";
import { getEffects } from "../../../../../utils/apis/effects/Effects";
import { IDS } from "../../../../../utils/common";
import { Context } from "../../../../../utils/context";

const CardSection = ({setActive}) => {
  const HtmlToReactParser = require("html-to-react").Parser;
  const htmlToReactParser = new HtmlToReactParser();

  const navigate = useNavigate();

  const [effect, setEffect] = useState([]);

  const { IMG_URL } = useContext(Context);

  const getEffect = async () => {
    const res = await getEffects();
    if (res?.success) {
      setEffect(res.data);
    }
  };
  useEffect(() => {
    getEffect();
  }, []);

  const handleServiceClick = (id) => {
    navigate(`/effect/${id}`);
  };

  const data = [
    {
      name: "Flame Effects",
      categoryId: 2,
      description:
        "High-impact fire visuals for stage performances and live shows.",
      image: "/assets/images/gallary/img1.png",
    },
    {
      name: "Cold / Ice Effects",
      categoryId: 3,
      description:
        "Create stunning icy atmospheres with fog and chilling visuals.",
      image: "/assets/images/gallary/img2.png",
    },
    {
      name: "Electric Effects",
      categoryId: 4,
      description:
        "Add energy to your event with lightning-style visual effects.",
      image: "/assets/images/gallary/img3.png",
    },
    {
      name: "Electric Effects",
      categoryId: 5,
      description:
        "Add energy to your event with lightning-style visual effects.",
      image: "/assets/images/gallary/img4.png",
    },
    {
      name: "Electric Effects",
      categoryId: 6,
      description:
        "Add energy to your event with lightning-style visual effects.",
      image: "/assets/images/gallary/img5.png",
    },
  ];

  return (
    <section className="Solar_Power all-card-section">
      <div className="solar_card_div container">
        <div className="row justify-content-center">
          {effect?.map((item, index) => (
            <div
              className="col-lg-4 col-md-6 col-sm-6 col-12 mb-2 mt-3"
              key={index}
            >
              <div
                className="solar_box"
                // onClick={() =>
                //   navigate("/categories", {
                //     state: { activeTab: item.categoryId },
                //   })
                // }
                onClick={() => setActive(item.id)}
              >
                <div className="solar_img_div">
                  <img
                    src={IDS?.IMG_URL + item?.image}
                    alt={item?.name}
                    className="solar_img"
                  />
                </div>

                <div className="solar_content">
                  <div className="text-wrapper">
                    <h5 className="card_title">{item?.name}</h5>

                    <p className="card_text">
                      {htmlToReactParser.parse(item?.sub_title)}
                    </p>
                  </div>

                  <div className="red-btn">
                    <div className="arrow-btn">
                      <FontAwesomeIcon icon={faAngleRight} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CardSection;
